package com.eladfinish.bible.contest.screens.completeVerse.model

enum class CompleteMode {
    MISSING_WORDS_UNDERLINE,
    MISSING_WORDS_3_DOTS,
    HIDE_SOME_WORDS,
}

// indicate the revealed part of the verse
enum class VersePart {
    BEFORE_ATNACHTA,
    AFTER_ATNACHTA,
}
